import axios from "axios";
import { API_BASE_URL } from "configs/AppConfig";
//import { AUTH_TOKEN } from "redux/constants/Auth";
import { notification } from "antd";
import store from '../redux/store';
import { setUser, signOutSuccess } from 'redux/actions/Auth'
import { generateRequestId, REQUEST_ID_HEADER } from 'utils/requestId'

const service = axios.create({
  baseURL: API_BASE_URL,
  timeout: 60000,
  withCredentials: true,
});

// Config
const ENTRY_ROUTE = "/auth/login";
//const TOKEN_PAYLOAD_KEY = "authorization";
const PUBLIC_REQUEST_KEY = "public-request";

// API Request interceptor
service.interceptors.request.use(
  (config) => {
    if (config.headers[PUBLIC_REQUEST_KEY]) {
      config.withCredentials = false;
    }
    config.headers[REQUEST_ID_HEADER] = config.headers[REQUEST_ID_HEADER] || generateRequestId();
    return config;
  },
  (error) => {
    console.log(error);

    // Do something with request error here
    notification.error({
      message: "Error",
    });
    Promise.reject(error);
  }
);

// API respone interceptor
service.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    let notificationParam = {
      message: "Server Error please try again",
    };

    if (error.response) {


      // Remove token and redirect
      if (error.response.status === 403) {
        if (error.response.data?.message === "User is not active" && window.location.pathname === ENTRY_ROUTE) {
          notificationParam.message = "Your user account no longer active.";
          notificationParam.description = "Contact administrator for more information";
          store.dispatch(setUser({
            username: "",
            role: "ROLE_USER",
            roles: [],
            token: null,
            code: "",
            credit: 0,
            avatar: null
          }))
        } else {
          notificationParam.message = "Unauthorized";
          if (error.response.data.error.details !== undefined) {
            notificationParam.description = error.response.data.error.details;;
          } else {
            notificationParam.description = "User is unauthorized";
          }
          /* store.dispatch(setUser({
            username: "",
            role: "ROLE_USER",
            code: "",
            credit: 0,
            avatar: null
          }))
          history.push(ENTRY_ROUTE); */
        }

      }

      if (error.response.status === 401) {
        console.log(error.response.data);
        if ((error.response.data?.message === "Missing JWT Refresh Token" || error.response.data?.message === "JWT Refresh Token Not Found") && window.location.pathname !== ENTRY_ROUTE) {

          notificationParam.message = "Session Expired";
          notificationParam.description = "Please login again";

          // Clear user state
          store.dispatch(signOutSuccess());
          store.dispatch(setUser({
            username: "",
            role: "ROLE_USER",
            roles: [],
            token: null,
            redirect: ENTRY_ROUTE,
            code: "",
            credit: 0,
            avatar: null,
            country: {
              id: null,
              name: "",
              isoCode: "",
            },
            currency: {
              id: null,
              name: "",
              code: "",
              symbol: "",
              rate: 0,
            },
          }));

          // Show notification; the redux state change above (token: null)
          // lets the route guards redirect to the login page in-app.
          notification.error(notificationParam);

          return Promise.reject(error);
        } else if (error.response.data?.message === "JWT Token not found" && window.location.pathname !== ENTRY_ROUTE && window.location.pathname !== '/notfound') {
          notificationParam.message = "UNAUTHORIZED";
          notificationParam.description = "please refresh the page"
          store.dispatch(signOutSuccess());
        } else if (error.response.data?.message === "Your user account no longer active.") {
          notificationParam.message = "Your user account no longer active.";
          notificationParam.description = "Contact administrator for more information";
          store.dispatch(setUser({
            username: "",
            role: "ROLE_USER",
            roles: [],
            token: null,
            redirect: ENTRY_ROUTE,
            code: "",
            credit: 0,
            avatar: null,
            loading: false
          }))
        }
        return Promise.reject(error);
      }

      if (error.response.status === 404) {
        notificationParam.message = "Not Found";
        notificationParam.description = error.response.data.error.details;
      }

      if (error.response.status === 406) {
        notificationParam.message = "Not Acceptable";
        notificationParam.description = <><p>{error.response.data.error.details}</p><img src={`/img/others/unaccaptable.jpg`} width={"100%"} alt="404" /></>;//error.response.data.error.details + " unaccaptabbbbbbbbbbbbbbbbbbbbbbbble condddddddddddddddddddddditionnnnnnnnnnnnnnnnn";
        //notificationParam.icon = <img src={`/img/others/unaccaptable.jpg`} height={100} alt="404" />;
      }

      if (error.response.status === 400) {
        notificationParam.message = "Not Found";
        notificationParam.description = error.response.data.error.details;
      }

      if (error.response.status === 500) {
        notificationParam.message = "Internal Server Error";

        notificationParam.description = error.response.data.error.details;
      }

      if (error.response.status === 508) {
        notificationParam.message = "Time Out";
        notificationParam.description = error.response.data.error.details;
      }
    } else {
      notificationParam.message = "No Server Response";
      if (error.response !== undefined) {
        if (error.response.data.error.details !== undefined) {
          notificationParam.description = error.response.data.error.details;
        }
      }
      //localStorage.removeItem(AUTH_TOKEN);
      //history.push(ENTRY_ROUTE);
      //window.location.reload();
    }

    notification.error(notificationParam);

    return Promise.reject(error);
  }
);

export default service;
